/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as ContentRouteRouteImport } from './routes/content/route'
import { Route as AppExplorerRouteRouteImport } from './routes/_app/explorer/route'
import { Route as ContentAboutRouteImport } from './routes/content/about'
import { Route as ContentIntroductionRouteImport } from './routes/content/introduction'
import { Route as ContentPrivacyRouteImport } from './routes/content/privacy'
import { Route as ContentTermsOfUseRouteImport } from './routes/content/terms-of-use'
import { Route as AppDatasetsIndexRouteImport } from './routes/_app/datasets.index'
import { Route as AppDatasetsSlugRouteImport } from './routes/_app/datasets.$slug'
import { Route as AppDiagnosticsIndexRouteImport } from './routes/_app/diagnostics.index'
import { Route as AppExecutionsIndexRouteImport } from './routes/_app/executions.index'
import { Route as AppExecutionsGroupIdRouteRouteImport } from './routes/_app/executions.$groupId/route'
import { Route as AppExecutionsResourcesRouteImport } from './routes/_app/executions.resources'
import { Route as AppExplorerIndexRouteImport } from './routes/_app/explorer/index'
import { Route as AppExplorerThemesRouteImport } from './routes/_app/explorer/themes'
import { Route as AppModelsIndexRouteImport } from './routes/_app/models.index'
import { Route as AppModelsSourceIdRouteImport } from './routes/_app/models.$sourceId'
import { Route as AppSettingsApiEndpointRouteImport } from './routes/_app/settings.api-endpoint'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/route'
import { Route as AppExecutionsGroupIdIndexRouteImport } from './routes/_app/executions.$groupId/index'
import { Route as AppExecutionsGroupIdDatasetsRouteImport } from './routes/_app/executions.$groupId/datasets'
import { Route as AppExecutionsGroupIdExecutionsRouteImport } from './routes/_app/executions.$groupId/executions'
import { Route as AppExecutionsGroupIdFilesRouteImport } from './routes/_app/executions.$groupId/files'
import { Route as AppExecutionsGroupIdLogsRouteImport } from './routes/_app/executions.$groupId/logs'
import { Route as AppExecutionsGroupIdScalarRouteImport } from './routes/_app/executions.$groupId/scalar'
import { Route as AppExecutionsGroupIdSeriesRouteImport } from './routes/_app/executions.$groupId/series'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugIndexRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/index'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugExplorerRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/explorer'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugFiguresRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/figures'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugGroupsRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/groups'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugScalarsRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/scalars'
import { Route as AppDiagnosticsProviderSlugDiagnosticSlugSeriesRouteImport } from './routes/_app/diagnostics.$providerSlug.$diagnosticSlug/series'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentRouteRoute = ContentRouteRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => rootRouteImport,
} as any)
const AppExplorerRouteRoute = AppExplorerRouteRouteImport.update({
  id: '/explorer',
  path: '/explorer',
  getParentRoute: () => AppRouteRoute,
} as any)
const ContentAboutRoute = ContentAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentIntroductionRoute = ContentIntroductionRouteImport.update({
  id: '/introduction',
  path: '/introduction',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentPrivacyRoute = ContentPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => ContentRouteRoute,
} as any)
const ContentTermsOfUseRoute = ContentTermsOfUseRouteImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => ContentRouteRoute,
} as any)
const AppDatasetsIndexRoute = AppDatasetsIndexRouteImport.update({
  id: '/datasets/',
  path: '/datasets/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDatasetsSlugRoute = AppDatasetsSlugRouteImport.update({
  id: '/datasets/$slug',
  path: '/datasets/$slug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDiagnosticsIndexRoute = AppDiagnosticsIndexRouteImport.update({
  id: '/diagnostics/',
  path: '/diagnostics/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExecutionsIndexRoute = AppExecutionsIndexRouteImport.update({
  id: '/executions/',
  path: '/executions/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExecutionsGroupIdRouteRoute =
  AppExecutionsGroupIdRouteRouteImport.update({
    id: '/executions/$groupId',
    path: '/executions/$groupId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppExecutionsResourcesRoute = AppExecutionsResourcesRouteImport.update({
  id: '/executions/resources',
  path: '/executions/resources',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExplorerIndexRoute = AppExplorerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppExplorerRouteRoute,
} as any)
const AppExplorerThemesRoute = AppExplorerThemesRouteImport.update({
  id: '/themes',
  path: '/themes',
  getParentRoute: () => AppExplorerRouteRoute,
} as any)
const AppModelsIndexRoute = AppModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppModelsSourceIdRoute = AppModelsSourceIdRouteImport.update({
  id: '/models/$sourceId',
  path: '/models/$sourceId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsApiEndpointRoute = AppSettingsApiEndpointRouteImport.update({
  id: '/settings/api-endpoint',
  path: '/settings/api-endpoint',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteImport.update({
    id: '/diagnostics/$providerSlug/$diagnosticSlug',
    path: '/diagnostics/$providerSlug/$diagnosticSlug',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppExecutionsGroupIdIndexRoute =
  AppExecutionsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppExecutionsGroupIdDatasetsRoute =
  AppExecutionsGroupIdDatasetsRouteImport.update({
    id: '/datasets',
    path: '/datasets',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppExecutionsGroupIdExecutionsRoute =
  AppExecutionsGroupIdExecutionsRouteImport.update({
    id: '/executions',
    path: '/executions',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppExecutionsGroupIdFilesRoute =
  AppExecutionsGroupIdFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppExecutionsGroupIdLogsRoute =
  AppExecutionsGroupIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppExecutionsGroupIdScalarRoute =
  AppExecutionsGroupIdScalarRouteImport.update({
    id: '/scalar',
    path: '/scalar',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppExecutionsGroupIdSeriesRoute =
  AppExecutionsGroupIdSeriesRouteImport.update({
    id: '/series',
    path: '/series',
    getParentRoute: () => AppExecutionsGroupIdRouteRoute,
  } as any)
const AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute,
  } as any)
const AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugExplorerRouteImport.update({
    id: '/explorer',
    path: '/explorer',
    getParentRoute: () => AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute,
  } as any)
const AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugFiguresRouteImport.update({
    id: '/figures',
    path: '/figures',
    getParentRoute: () => AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute,
  } as any)
const AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute,
  } as any)
const AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugScalarsRouteImport.update({
    id: '/scalars',
    path: '/scalars',
    getParentRoute: () => AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute,
  } as any)
const AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute =
  AppDiagnosticsProviderSlugDiagnosticSlugSeriesRouteImport.update({
    id: '/series',
    path: '/series',
    getParentRoute: () => AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/content': typeof ContentRouteRouteWithChildren
  '/explorer': typeof AppExplorerRouteRouteWithChildren
  '/content/about': typeof ContentAboutRoute
  '/content/introduction': typeof ContentIntroductionRoute
  '/content/privacy': typeof ContentPrivacyRoute
  '/content/terms-of-use': typeof ContentTermsOfUseRoute
  '/executions/$groupId': typeof AppExecutionsGroupIdRouteRouteWithChildren
  '/datasets/$slug': typeof AppDatasetsSlugRoute
  '/executions/resources': typeof AppExecutionsResourcesRoute
  '/explorer/themes': typeof AppExplorerThemesRoute
  '/models/$sourceId': typeof AppModelsSourceIdRoute
  '/settings/api-endpoint': typeof AppSettingsApiEndpointRoute
  '/datasets/': typeof AppDatasetsIndexRoute
  '/diagnostics/': typeof AppDiagnosticsIndexRoute
  '/executions/': typeof AppExecutionsIndexRoute
  '/explorer/': typeof AppExplorerIndexRoute
  '/models/': typeof AppModelsIndexRoute
  '/diagnostics/$providerSlug/$diagnosticSlug': typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteWithChildren
  '/executions/$groupId/datasets': typeof AppExecutionsGroupIdDatasetsRoute
  '/executions/$groupId/executions': typeof AppExecutionsGroupIdExecutionsRoute
  '/executions/$groupId/files': typeof AppExecutionsGroupIdFilesRoute
  '/executions/$groupId/logs': typeof AppExecutionsGroupIdLogsRoute
  '/executions/$groupId/scalar': typeof AppExecutionsGroupIdScalarRoute
  '/executions/$groupId/series': typeof AppExecutionsGroupIdSeriesRoute
  '/executions/$groupId/': typeof AppExecutionsGroupIdIndexRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/explorer': typeof AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/figures': typeof AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/groups': typeof AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/scalars': typeof AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/series': typeof AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/': typeof AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/content': typeof ContentRouteRouteWithChildren
  '/content/about': typeof ContentAboutRoute
  '/content/introduction': typeof ContentIntroductionRoute
  '/content/privacy': typeof ContentPrivacyRoute
  '/content/terms-of-use': typeof ContentTermsOfUseRoute
  '/datasets/$slug': typeof AppDatasetsSlugRoute
  '/executions/resources': typeof AppExecutionsResourcesRoute
  '/explorer/themes': typeof AppExplorerThemesRoute
  '/models/$sourceId': typeof AppModelsSourceIdRoute
  '/settings/api-endpoint': typeof AppSettingsApiEndpointRoute
  '/datasets': typeof AppDatasetsIndexRoute
  '/diagnostics': typeof AppDiagnosticsIndexRoute
  '/executions': typeof AppExecutionsIndexRoute
  '/explorer': typeof AppExplorerIndexRoute
  '/models': typeof AppModelsIndexRoute
  '/executions/$groupId/datasets': typeof AppExecutionsGroupIdDatasetsRoute
  '/executions/$groupId/executions': typeof AppExecutionsGroupIdExecutionsRoute
  '/executions/$groupId/files': typeof AppExecutionsGroupIdFilesRoute
  '/executions/$groupId/logs': typeof AppExecutionsGroupIdLogsRoute
  '/executions/$groupId/scalar': typeof AppExecutionsGroupIdScalarRoute
  '/executions/$groupId/series': typeof AppExecutionsGroupIdSeriesRoute
  '/executions/$groupId': typeof AppExecutionsGroupIdIndexRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/explorer': typeof AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/figures': typeof AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/groups': typeof AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/scalars': typeof AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute
  '/diagnostics/$providerSlug/$diagnosticSlug/series': typeof AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute
  '/diagnostics/$providerSlug/$diagnosticSlug': typeof AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/content': typeof ContentRouteRouteWithChildren
  '/_app/explorer': typeof AppExplorerRouteRouteWithChildren
  '/content/about': typeof ContentAboutRoute
  '/content/introduction': typeof ContentIntroductionRoute
  '/content/privacy': typeof ContentPrivacyRoute
  '/content/terms-of-use': typeof ContentTermsOfUseRoute
  '/_app/executions/$groupId': typeof AppExecutionsGroupIdRouteRouteWithChildren
  '/_app/datasets/$slug': typeof AppDatasetsSlugRoute
  '/_app/executions/resources': typeof AppExecutionsResourcesRoute
  '/_app/explorer/themes': typeof AppExplorerThemesRoute
  '/_app/models/$sourceId': typeof AppModelsSourceIdRoute
  '/_app/settings/api-endpoint': typeof AppSettingsApiEndpointRoute
  '/_app/datasets/': typeof AppDatasetsIndexRoute
  '/_app/diagnostics/': typeof AppDiagnosticsIndexRoute
  '/_app/executions/': typeof AppExecutionsIndexRoute
  '/_app/explorer/': typeof AppExplorerIndexRoute
  '/_app/models/': typeof AppModelsIndexRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug': typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteWithChildren
  '/_app/executions/$groupId/datasets': typeof AppExecutionsGroupIdDatasetsRoute
  '/_app/executions/$groupId/executions': typeof AppExecutionsGroupIdExecutionsRoute
  '/_app/executions/$groupId/files': typeof AppExecutionsGroupIdFilesRoute
  '/_app/executions/$groupId/logs': typeof AppExecutionsGroupIdLogsRoute
  '/_app/executions/$groupId/scalar': typeof AppExecutionsGroupIdScalarRoute
  '/_app/executions/$groupId/series': typeof AppExecutionsGroupIdSeriesRoute
  '/_app/executions/$groupId/': typeof AppExecutionsGroupIdIndexRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug/explorer': typeof AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug/figures': typeof AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug/groups': typeof AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug/scalars': typeof AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug/series': typeof AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute
  '/_app/diagnostics/$providerSlug/$diagnosticSlug/': typeof AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/content'
    | '/explorer'
    | '/content/about'
    | '/content/introduction'
    | '/content/privacy'
    | '/content/terms-of-use'
    | '/executions/$groupId'
    | '/datasets/$slug'
    | '/executions/resources'
    | '/explorer/themes'
    | '/models/$sourceId'
    | '/settings/api-endpoint'
    | '/datasets/'
    | '/diagnostics/'
    | '/executions/'
    | '/explorer/'
    | '/models/'
    | '/diagnostics/$providerSlug/$diagnosticSlug'
    | '/executions/$groupId/datasets'
    | '/executions/$groupId/executions'
    | '/executions/$groupId/files'
    | '/executions/$groupId/logs'
    | '/executions/$groupId/scalar'
    | '/executions/$groupId/series'
    | '/executions/$groupId/'
    | '/diagnostics/$providerSlug/$diagnosticSlug/explorer'
    | '/diagnostics/$providerSlug/$diagnosticSlug/figures'
    | '/diagnostics/$providerSlug/$diagnosticSlug/groups'
    | '/diagnostics/$providerSlug/$diagnosticSlug/scalars'
    | '/diagnostics/$providerSlug/$diagnosticSlug/series'
    | '/diagnostics/$providerSlug/$diagnosticSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/content'
    | '/content/about'
    | '/content/introduction'
    | '/content/privacy'
    | '/content/terms-of-use'
    | '/datasets/$slug'
    | '/executions/resources'
    | '/explorer/themes'
    | '/models/$sourceId'
    | '/settings/api-endpoint'
    | '/datasets'
    | '/diagnostics'
    | '/executions'
    | '/explorer'
    | '/models'
    | '/executions/$groupId/datasets'
    | '/executions/$groupId/executions'
    | '/executions/$groupId/files'
    | '/executions/$groupId/logs'
    | '/executions/$groupId/scalar'
    | '/executions/$groupId/series'
    | '/executions/$groupId'
    | '/diagnostics/$providerSlug/$diagnosticSlug/explorer'
    | '/diagnostics/$providerSlug/$diagnosticSlug/figures'
    | '/diagnostics/$providerSlug/$diagnosticSlug/groups'
    | '/diagnostics/$providerSlug/$diagnosticSlug/scalars'
    | '/diagnostics/$providerSlug/$diagnosticSlug/series'
    | '/diagnostics/$providerSlug/$diagnosticSlug'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/content'
    | '/_app/explorer'
    | '/content/about'
    | '/content/introduction'
    | '/content/privacy'
    | '/content/terms-of-use'
    | '/_app/executions/$groupId'
    | '/_app/datasets/$slug'
    | '/_app/executions/resources'
    | '/_app/explorer/themes'
    | '/_app/models/$sourceId'
    | '/_app/settings/api-endpoint'
    | '/_app/datasets/'
    | '/_app/diagnostics/'
    | '/_app/executions/'
    | '/_app/explorer/'
    | '/_app/models/'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug'
    | '/_app/executions/$groupId/datasets'
    | '/_app/executions/$groupId/executions'
    | '/_app/executions/$groupId/files'
    | '/_app/executions/$groupId/logs'
    | '/_app/executions/$groupId/scalar'
    | '/_app/executions/$groupId/series'
    | '/_app/executions/$groupId/'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug/explorer'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug/figures'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug/groups'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug/scalars'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug/series'
    | '/_app/diagnostics/$providerSlug/$diagnosticSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ContentRouteRoute: typeof ContentRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content': {
      id: '/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof ContentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/explorer': {
      id: '/_app/explorer'
      path: '/explorer'
      fullPath: '/explorer'
      preLoaderRoute: typeof AppExplorerRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/content/about': {
      id: '/content/about'
      path: '/about'
      fullPath: '/content/about'
      preLoaderRoute: typeof ContentAboutRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/introduction': {
      id: '/content/introduction'
      path: '/introduction'
      fullPath: '/content/introduction'
      preLoaderRoute: typeof ContentIntroductionRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/privacy': {
      id: '/content/privacy'
      path: '/privacy'
      fullPath: '/content/privacy'
      preLoaderRoute: typeof ContentPrivacyRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/content/terms-of-use': {
      id: '/content/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/content/terms-of-use'
      preLoaderRoute: typeof ContentTermsOfUseRouteImport
      parentRoute: typeof ContentRouteRoute
    }
    '/_app/datasets/': {
      id: '/_app/datasets/'
      path: '/datasets'
      fullPath: '/datasets/'
      preLoaderRoute: typeof AppDatasetsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/datasets/$slug': {
      id: '/_app/datasets/$slug'
      path: '/datasets/$slug'
      fullPath: '/datasets/$slug'
      preLoaderRoute: typeof AppDatasetsSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/diagnostics/': {
      id: '/_app/diagnostics/'
      path: '/diagnostics'
      fullPath: '/diagnostics/'
      preLoaderRoute: typeof AppDiagnosticsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/executions/': {
      id: '/_app/executions/'
      path: '/executions'
      fullPath: '/executions/'
      preLoaderRoute: typeof AppExecutionsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/executions/$groupId': {
      id: '/_app/executions/$groupId'
      path: '/executions/$groupId'
      fullPath: '/executions/$groupId'
      preLoaderRoute: typeof AppExecutionsGroupIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/executions/resources': {
      id: '/_app/executions/resources'
      path: '/executions/resources'
      fullPath: '/executions/resources'
      preLoaderRoute: typeof AppExecutionsResourcesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/explorer/': {
      id: '/_app/explorer/'
      path: '/'
      fullPath: '/explorer/'
      preLoaderRoute: typeof AppExplorerIndexRouteImport
      parentRoute: typeof AppExplorerRouteRoute
    }
    '/_app/explorer/themes': {
      id: '/_app/explorer/themes'
      path: '/themes'
      fullPath: '/explorer/themes'
      preLoaderRoute: typeof AppExplorerThemesRouteImport
      parentRoute: typeof AppExplorerRouteRoute
    }
    '/_app/models/': {
      id: '/_app/models/'
      path: '/models'
      fullPath: '/models/'
      preLoaderRoute: typeof AppModelsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/models/$sourceId': {
      id: '/_app/models/$sourceId'
      path: '/models/$sourceId'
      fullPath: '/models/$sourceId'
      preLoaderRoute: typeof AppModelsSourceIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/api-endpoint': {
      id: '/_app/settings/api-endpoint'
      path: '/settings/api-endpoint'
      fullPath: '/settings/api-endpoint'
      preLoaderRoute: typeof AppSettingsApiEndpointRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug'
      path: '/diagnostics/$providerSlug/$diagnosticSlug'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/executions/$groupId/': {
      id: '/_app/executions/$groupId/'
      path: '/'
      fullPath: '/executions/$groupId/'
      preLoaderRoute: typeof AppExecutionsGroupIdIndexRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/executions/$groupId/datasets': {
      id: '/_app/executions/$groupId/datasets'
      path: '/datasets'
      fullPath: '/executions/$groupId/datasets'
      preLoaderRoute: typeof AppExecutionsGroupIdDatasetsRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/executions/$groupId/executions': {
      id: '/_app/executions/$groupId/executions'
      path: '/executions'
      fullPath: '/executions/$groupId/executions'
      preLoaderRoute: typeof AppExecutionsGroupIdExecutionsRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/executions/$groupId/files': {
      id: '/_app/executions/$groupId/files'
      path: '/files'
      fullPath: '/executions/$groupId/files'
      preLoaderRoute: typeof AppExecutionsGroupIdFilesRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/executions/$groupId/logs': {
      id: '/_app/executions/$groupId/logs'
      path: '/logs'
      fullPath: '/executions/$groupId/logs'
      preLoaderRoute: typeof AppExecutionsGroupIdLogsRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/executions/$groupId/scalar': {
      id: '/_app/executions/$groupId/scalar'
      path: '/scalar'
      fullPath: '/executions/$groupId/scalar'
      preLoaderRoute: typeof AppExecutionsGroupIdScalarRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/executions/$groupId/series': {
      id: '/_app/executions/$groupId/series'
      path: '/series'
      fullPath: '/executions/$groupId/series'
      preLoaderRoute: typeof AppExecutionsGroupIdSeriesRouteImport
      parentRoute: typeof AppExecutionsGroupIdRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug/': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug/'
      path: '/'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug/'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugIndexRouteImport
      parentRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug/explorer': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug/explorer'
      path: '/explorer'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug/explorer'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugExplorerRouteImport
      parentRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug/figures': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug/figures'
      path: '/figures'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug/figures'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugFiguresRouteImport
      parentRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug/groups': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug/groups'
      path: '/groups'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug/groups'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugGroupsRouteImport
      parentRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug/scalars': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug/scalars'
      path: '/scalars'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug/scalars'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugScalarsRouteImport
      parentRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute
    }
    '/_app/diagnostics/$providerSlug/$diagnosticSlug/series': {
      id: '/_app/diagnostics/$providerSlug/$diagnosticSlug/series'
      path: '/series'
      fullPath: '/diagnostics/$providerSlug/$diagnosticSlug/series'
      preLoaderRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugSeriesRouteImport
      parentRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute
    }
  }
}

interface AppExplorerRouteRouteChildren {
  AppExplorerThemesRoute: typeof AppExplorerThemesRoute
  AppExplorerIndexRoute: typeof AppExplorerIndexRoute
}

const AppExplorerRouteRouteChildren: AppExplorerRouteRouteChildren = {
  AppExplorerThemesRoute: AppExplorerThemesRoute,
  AppExplorerIndexRoute: AppExplorerIndexRoute,
}

const AppExplorerRouteRouteWithChildren =
  AppExplorerRouteRoute._addFileChildren(AppExplorerRouteRouteChildren)

interface AppExecutionsGroupIdRouteRouteChildren {
  AppExecutionsGroupIdDatasetsRoute: typeof AppExecutionsGroupIdDatasetsRoute
  AppExecutionsGroupIdExecutionsRoute: typeof AppExecutionsGroupIdExecutionsRoute
  AppExecutionsGroupIdFilesRoute: typeof AppExecutionsGroupIdFilesRoute
  AppExecutionsGroupIdLogsRoute: typeof AppExecutionsGroupIdLogsRoute
  AppExecutionsGroupIdScalarRoute: typeof AppExecutionsGroupIdScalarRoute
  AppExecutionsGroupIdSeriesRoute: typeof AppExecutionsGroupIdSeriesRoute
  AppExecutionsGroupIdIndexRoute: typeof AppExecutionsGroupIdIndexRoute
}

const AppExecutionsGroupIdRouteRouteChildren: AppExecutionsGroupIdRouteRouteChildren =
  {
    AppExecutionsGroupIdDatasetsRoute: AppExecutionsGroupIdDatasetsRoute,
    AppExecutionsGroupIdExecutionsRoute: AppExecutionsGroupIdExecutionsRoute,
    AppExecutionsGroupIdFilesRoute: AppExecutionsGroupIdFilesRoute,
    AppExecutionsGroupIdLogsRoute: AppExecutionsGroupIdLogsRoute,
    AppExecutionsGroupIdScalarRoute: AppExecutionsGroupIdScalarRoute,
    AppExecutionsGroupIdSeriesRoute: AppExecutionsGroupIdSeriesRoute,
    AppExecutionsGroupIdIndexRoute: AppExecutionsGroupIdIndexRoute,
  }

const AppExecutionsGroupIdRouteRouteWithChildren =
  AppExecutionsGroupIdRouteRoute._addFileChildren(
    AppExecutionsGroupIdRouteRouteChildren,
  )

interface AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteChildren {
  AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute
  AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute
  AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute
  AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute
  AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute
  AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute
}

const AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteChildren: AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteChildren =
  {
    AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute:
      AppDiagnosticsProviderSlugDiagnosticSlugExplorerRoute,
    AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute:
      AppDiagnosticsProviderSlugDiagnosticSlugFiguresRoute,
    AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute:
      AppDiagnosticsProviderSlugDiagnosticSlugGroupsRoute,
    AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute:
      AppDiagnosticsProviderSlugDiagnosticSlugScalarsRoute,
    AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute:
      AppDiagnosticsProviderSlugDiagnosticSlugSeriesRoute,
    AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute:
      AppDiagnosticsProviderSlugDiagnosticSlugIndexRoute,
  }

const AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteWithChildren =
  AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute._addFileChildren(
    AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppExplorerRouteRoute: typeof AppExplorerRouteRouteWithChildren
  AppExecutionsGroupIdRouteRoute: typeof AppExecutionsGroupIdRouteRouteWithChildren
  AppDatasetsSlugRoute: typeof AppDatasetsSlugRoute
  AppExecutionsResourcesRoute: typeof AppExecutionsResourcesRoute
  AppModelsSourceIdRoute: typeof AppModelsSourceIdRoute
  AppSettingsApiEndpointRoute: typeof AppSettingsApiEndpointRoute
  AppDatasetsIndexRoute: typeof AppDatasetsIndexRoute
  AppDiagnosticsIndexRoute: typeof AppDiagnosticsIndexRoute
  AppExecutionsIndexRoute: typeof AppExecutionsIndexRoute
  AppModelsIndexRoute: typeof AppModelsIndexRoute
  AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute: typeof AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppExplorerRouteRoute: AppExplorerRouteRouteWithChildren,
  AppExecutionsGroupIdRouteRoute: AppExecutionsGroupIdRouteRouteWithChildren,
  AppDatasetsSlugRoute: AppDatasetsSlugRoute,
  AppExecutionsResourcesRoute: AppExecutionsResourcesRoute,
  AppModelsSourceIdRoute: AppModelsSourceIdRoute,
  AppSettingsApiEndpointRoute: AppSettingsApiEndpointRoute,
  AppDatasetsIndexRoute: AppDatasetsIndexRoute,
  AppDiagnosticsIndexRoute: AppDiagnosticsIndexRoute,
  AppExecutionsIndexRoute: AppExecutionsIndexRoute,
  AppModelsIndexRoute: AppModelsIndexRoute,
  AppDiagnosticsProviderSlugDiagnosticSlugRouteRoute:
    AppDiagnosticsProviderSlugDiagnosticSlugRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface ContentRouteRouteChildren {
  ContentAboutRoute: typeof ContentAboutRoute
  ContentIntroductionRoute: typeof ContentIntroductionRoute
  ContentPrivacyRoute: typeof ContentPrivacyRoute
  ContentTermsOfUseRoute: typeof ContentTermsOfUseRoute
}

const ContentRouteRouteChildren: ContentRouteRouteChildren = {
  ContentAboutRoute: ContentAboutRoute,
  ContentIntroductionRoute: ContentIntroductionRoute,
  ContentPrivacyRoute: ContentPrivacyRoute,
  ContentTermsOfUseRoute: ContentTermsOfUseRoute,
}

const ContentRouteRouteWithChildren = ContentRouteRoute._addFileChildren(
  ContentRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  ContentRouteRoute: ContentRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
